import React, { useState, useEffect } from 'react';
import { PivotTable } from 'src/mtska-frontend-app-component';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";

const Pivot = ({ dataProviderName, filters: defaultFilters }) => {
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        setLocalFilterModel({ items: [...filterModel.items] });
        setLocalDrawable(true);
    }, [filterModel])

    return (localDrawable &&
        <PivotTable
            dataProviderName="statisticsviews/proposal/pivot/views_opportunities_proposal"
            filters={localFilterModel}
            format="number"
            rows={[
                { field: '_related_source_name', sort: 'asc' },
                { field: '_related_area_name', sort: 'asc' },
                { field: '_related_shop_name', sort: 'asc' }
            ]}
            values={[
                { field: '_id', aggregate: 'count', format: 'number' }
            ]}
            columns={[
                { field: 'registered_at', bucket: 'month' }
            ]}
        />
    )
}

export default Pivot;
